var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddNewVoteIconTwoStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.2558,
    height: 32,
    rx: 15.6279,
    fill: "#FBFBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4436 21H18.8669V19.9062H14.134V19.8267L16.4209 17.3807C18.1709 15.5064 18.6879 14.6314 18.6879 13.5028C18.6879 11.9318 17.4152 10.679 15.6254 10.679C13.8406 10.679 12.4834 11.892 12.4834 13.6818H13.6567C13.6567 12.5234 14.4074 11.7528 15.5857 11.7528C16.6894 11.7528 17.5345 12.429 17.5345 13.5028C17.5345 14.4425 16.9827 15.1385 15.8044 16.4261L12.4436 20.1051V21Z",
    fill: "#363B4D",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 30.7558,
    height: 31.5,
    rx: 15.3779,
    stroke: "#363B4D",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewVoteIconTwoStep);
export default __webpack_public_path__ + "static/media/AddNewVoteIconTwoStep.05321e4ee902242e3ec610c091d57a3c.svg";
export { ForwardRef as ReactComponent };